import type React from "react";

import {
  Box,
  type BoxProps,
  Stack,
  type StackProps,
  Text,
  Title,
  type TitleProps,
} from "metabase/ui";

import S from "./SettingsSection.module.css";

export function SettingsSection({
  title,
  titleProps,
  description,
  children,
  id,
  stackProps,
  ...boxProps
}: {
  title?: React.ReactNode;
  titleProps?: TitleProps;
  description?: React.ReactNode;
  children?: React.ReactNode;
  id?: string;
  stackProps?: StackProps;
} & BoxProps) {
  return (
    <Box id={id} {...boxProps}>
      {children && (
        <Stack gap="lg" className={S.SettingsSection} {...stackProps}>
          {(title || description) && (
            <Box mb="sm">
              {title && (
                <Title order={2} {...titleProps}>
                  {title}
                </Title>
              )}
              {description && <Text c="text-secondary">{description}</Text>}
            </Box>
          )}
          {children}
        </Stack>
      )}
    </Box>
  );
}

export function SettingsPageWrapper({
  title,
  description,
  children,
  titleProps,
  ...stackProps
}: {
  title?: React.ReactNode;
  description?: React.ReactNode;
  children: React.ReactNode;
  titleProps?: TitleProps;
} & Omit<StackProps, "title">) {
  return (
    <Stack gap="lg" {...stackProps}>
      {(title || description) && (
        <Box>
          {title && (
            <Title
              order={1}
              display="flex"
              style={{ alignItems: "center" }}
              {...titleProps}
            >
              {title}
            </Title>
          )}
          {description && (
            <Text c="text-secondary" maw="40rem">
              {description}
            </Text>
          )}
        </Box>
      )}
      {children}
    </Stack>
  );
}
